import script from "./dialog-staff-time-off.vue?vue&type=script&setup=true&lang=ts"
export * from "./dialog-staff-time-off.vue?vue&type=script&setup=true&lang=ts"

import "./dialog-staff-time-off.vue?vue&type=style&index=0&id=1a560d8e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a560d8e"]])

export default __exports__